import { render, staticRenderFns } from "./PresentationViewOnlyInfoBar.vue?vue&type=template&id=087c013a"
import script from "./PresentationViewOnlyInfoBar.vue?vue&type=script&lang=js"
export * from "./PresentationViewOnlyInfoBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports